import { create } from 'zustand'

/**
 * Sesión en memoria.
 *
 * Al recargar la página el token se pierde a propósito: `bootstrapSession()`
 * lo recupera desde la cookie HttpOnly de refresh. Ese viaje extra es el precio
 * de no dejar un token accesible a cualquier script inyectado.
 */
export const useSessionStore = create((set) => ({
  accessToken: null,
  user: null, // { public_id, full_name, role, company, locale }
  status: 'unknown', // unknown | authenticated | anonymous

  setSession: ({ access_token, user }) =>
    set({ accessToken: access_token, user: user ?? null, status: 'authenticated' }),

  clearSession: () => set({ accessToken: null, user: null, status: 'anonymous' }),

  markAnonymous: () => set({ status: 'anonymous' }),
}))

/** Selectores: evitan re-renders innecesarios al suscribirse a un solo campo. */
export const selectIsAuthenticated = (state) => state.status === 'authenticated'
export const selectRole = (state) => state.user?.role ?? null
